import { useDataModel } from '@thd-nucleus/data-sources';

export const usePartsAndServicesHook = ({ itemIds, storeZip, isCustomerIdentified, skip = false }) => {
  const { data, error, loading } = useDataModel('getPartsServices', {
    variables: {
      itemIds,
      storeZip,
      requestContext: {
        isBrandPricingPolicyCompliant: isCustomerIdentified
      }
    },
    skip
  });
  return { data, error, loading };
};
